import angular from 'angular';
import trainingDocument from '../trainingDocument';
import trainingWebinar from '../trainingWebinar';
import trainingPresentation from '../trainingPresentation';
import directive from './training-media-list.directive';


export default angular.module('app.components.support.trainingMediaList', [
  trainingDocument,
  trainingWebinar,
  trainingPresentation
])
  .directive('trainingMediaList', directive)
  .controller('TrainingMediaListController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.support.trainingMediaList created');
